export const MAINSLIDER = 'main'
export const SLIDER = 'slider'
export const STRIPE = 'stripe'
export const HIGHLIGHT = 'highlight'
export const WEISCHERADS = 'weischerAds'
export const SHOWTIMES = 'showtimes'
export const ADVERTISEMENT = 'advertisement'